<template>
  <div class="" :style=" {height:(data.style.height*0.9)+'px'}">
  </div>
</template>
<script>
export default {
  props: { data: Object }
};
</script>